module.exports = __webpack_public_path__ + "static/media/brainImageing.60c4fc4e.svg";